export const QUESTION_CATEGORY_PARAM = 'questionCategoryId'
export const SHOW_DELETED_PARAM = 'showDeleted'
